import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}superadmin_program`;

//  * Find Program Report
export function findProgramReport(queryParams) {
  return axios({
    method: "GET",
    url: `${URL}/`,
    params: queryParams
  });
}

// * Get Program Report Export
export function getProgramReportExport(queryParams) {
  return axios({
    method: "GET",
    url: `${URL}/export`,
    params: queryParams,
    responseType: "blob"
  });
}
